// extracted by mini-css-extract-plugin
export default {"container":"Main_container__y9CsB","main":"Main_main__4oUoa","sidebar":"Main_sidebar__o4g39","orderbook":"Main_orderbook__PCQfW","live_market":"Main_live_market__+H-9s"};